// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__YGO63","title":"InfoRow_title__3_W4g"};